import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "../Component/Login.css"; // custom CSS file
import jwt_decode from "jwt-decode";
import { API_BASE_URL } from "../config";

export default function Login({ setIsLoggedIn }) {  
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();  

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Logging in with:", email, password);
    setLoading(true);
    // TODO: connect to API
    try{
      const response = await fetch(`${API_BASE_URL}/api/auth/login`,{
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Email: email,
          Password: password
        }),
      });

      if (response.ok) {
          const data = await response.json();
          const token = data.token;
          // Save JWT token
        localStorage.setItem("token", token);
        // Decode JWT
        const decoded = jwt_decode(token);
        console.log("Decoded token:", decoded);
        // Get role from claim
        const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        localStorage.setItem("role", role);        
        setIsLoggedIn(true);        
           // ✅ set login state
        if(role ==="Admin"){
          navigate("/admindashboard");    
        }else{
          navigate("/dashboard"); // ✅ redirect after login
        }      
      } 
      
      else if (response.status === 401) {
      // Unauthorized (wrong credentials or not allowed)
      alert("Unauthorized: Invalid email or password.");
    } 
    
    else if (response.status === 403) {
      // Forbidden (valid credentials but no permission)
      alert("Access denied: You don’t have permission to access this resource.");
    } 
    
    else {
      // Other errors
      const errorData = await response.json().catch(() => ({}));
      alert("Error: " + (errorData.message || `Unexpected error (${response.status})`));
    }    
    } catch(err){
      console.error("Login error:", err);
      //alert("Something went wrong. Try again later.");
       if (err.name === "TypeError") {
    setError("Unable to connect to server. Please check internet or API URL.");
  } else {
    setError(err.message || "Something went wrong.");
  }
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo + Title */}
        <div className="login-header">
          <div className="logo-box">A</div>
          <h2>Login</h2>
          <p>Access your AdvocatePro account</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-primary">
            Sign In
          </button>
          {/* ERROR DISPLAY */}
            {error && <p style={{ color: "red" }}>{error}</p>}
        </form>

        {/* Links */}
        <div className="extra-links">
          <a href="#">Forgot password?</a>
          <p>
            Don’t have an account? <a href="/register">Register</a>
          </p>
        </div>
      </div>
    </div>
  );
}
